export const enum SportTag {
  GOLF = 'golf',
  SOCCER = 'soccer',
  FOOTBALL = 'football',
  BASEBALL = 'baseball',
  BASKETBALL = 'basketball',
  HOCKEY = 'hockey',
}
